import { createContext, type ReactNode } from 'react';
import type { formatNumberToCurrency as FormatNumberToCurrency } from '@/utils/currency';
import type { HorizontalBarDatum } from '../types';

export interface BarChartTooltipConfig {
  data: readonly HorizontalBarDatum[];
  formatCurrency?: typeof FormatNumberToCurrency;
  renderContent?: (datum: HorizontalBarDatum) => ReactNode;
}

/**
 * Carries the chart's data and renderer to its tooltip.
 *
 * The tooltip is a chart slot, so it cannot be handed props directly, and the
 * slot component has to be a single stable reference: an inline arrow is a new
 * component type on every render, which remounts the tooltip continuously and
 * can leave more than one of them on screen at once.
 */
export const BarChartTooltipContext =
  createContext<BarChartTooltipConfig | null>(null);

export const BarChartTooltipProvider = BarChartTooltipContext.Provider;
